import { render } from "./questionnaire.vue?vue&type=template&id=631b8c14"
import script from "./questionnaire.vue?vue&type=script&lang=js"
export * from "./questionnaire.vue?vue&type=script&lang=js"

import exportComponent from "/Users/wojtek/web/customer-zone/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__